import React, {useState, useEffect, useRef} from 'react';
import block from "bem-css-modules";
import selectDrop from "../../../styles/components/Utility/Selectdrop.module.scss";

const Select = (props) => {
  const [isOpen, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const container = useRef(null);

  const {label} = props;

    block.setSettings({
        modifierDelimiter: "--",
    });
    
    const select = block(selectDrop);

    const toggleDropdown = () => setOpen(!isOpen);
  
    const handleItemClick = (id) => {
      selectedItem == id ? setSelectedItem(null) : setSelectedItem(id);
      props.onChange(id);
    }
    
    const handleClickOutside = event => {
      if (container.current && !container.current.contains(event.target)) {
        setOpen(false);
      }
    };
  
    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    });
  
    return (
      <div className={select("")} ref={container}>
          {label && <span className={select("label")}>{label}</span> }
          <div className={select("header")} onClick={toggleDropdown}>
            {selectedItem ? props.list.find(item => item.id == selectedItem).label : "Select your destination"}
            <i className={`${select("icon")}` + ' ' + `${isOpen && select("icon--open")}`}></i>
          </div>
          <div className={`${select("body")}` + ' ' + `${isOpen && select("body--open")}`} onClick={toggleDropdown}>
            <div className={select('list')}>
            {props.list.map(item => (
              <div className={`${select("item")}` + ' ' + `${item.id == selectedItem && select("item--selected")}` } onClick={e => handleItemClick(e.target.id)} id={item.id} key={item.id}>
                <span className={`${select("dot")}` + ' ' + `${item.id == selectedItem && select("dot--selected")}`}>• </span>
                {item.label}
              </div>
            ))}
            </div>
          </div>        
      </div>
    );
  };

export default Select; 